module.exports = __webpack_public_path__ + "static/media/artist-perfoming-arts.0eb63555.jpeg";